import ShCard from '@/components/Helpers/ShCard';
import PermissionProfilesCategoryItem from './PermissionProfilesCategoryItem';

export default {
  name: 'PermissionProfilesCategory',

  components: {
    ShCard,
    PermissionProfilesCategoryItem,
  },

  props: {
    name: {
      type: String,
      default: 'Konfiguracja powiadomienia',
    },
    index: {
      type: Number,
      default: 1,
    },
    permissions: {
      type: Array,
    },
    profile: {
      type: Object,
    },
  },

  methods: {
    updateProfilePermission(permissionSlug) {
      this.$emit('updateProfilePermission', permissionSlug);
    },
  },
};
